/**
 * Generated runtime TestId mirror for frontend/src/pages/provisioning/ProvisioningTasks.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ProvisioningTasksTestIds = {
  btnBulkRetry: "btn-bulk-retry",
  btnRefresh: "btn-refresh",
  bulkRetryDialogTitle: "bulk-retry-dialog-title",
  checkSelectAll: "check-select-all",
  colAccount: "col-account",
  colAction: "col-action",
  colActions: "col-actions",
  colCreatedAt: "col-created-at",
  colEntitlement: "col-entitlement",
  colIdentity: "col-identity",
  colRetries: "col-retries",
  colSelect: "col-select",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  provisioningTasksList: "provisioning-tasks-list",
  btnRetryRow: (task_id: string) => `btn-retry-row-${task_id}`,
  btnRetryRowPrefix: () => "btn-retry-row-" as TestIdPrefix,
  checkRow: (task_id: string) => `check-row-${task_id}`,
  checkRowPrefix: () => "check-row-" as TestIdPrefix,
  linkIdentityDetail: (task_identity_id: string) => `link-identity-detail-${task_identity_id}`,
  linkIdentityDetailPrefix: () => "link-identity-detail-" as TestIdPrefix,
  taskRow: (task_id: string) => `task-row-${task_id}`,
  taskRowPrefix: () => "task-row-" as TestIdPrefix
} as const;
